export const pasteFieldConfirmDialog = {
  "title": "PDF Editor Cloud",
  "confirmMsg": "There is already at least one \"{fieldType}\" with the same name. Do you want to rename it to \"{newFieldName}\"?",
  "rememberBtn": "Remember this action and don't show again",
  "okBtn": "Yes",
  "noBtn": "No",
  "cancelBtn": "Cancel"
}